export default __webpack_public_path__ + "static/media/notStarted.3adca9b4.svg";